<template>
  <export-plant-dialog
    class="exportPlant"
    v-show="dialogVisible"
    :visible.sync="dialogVisible" 
    :width="'auto'"
    :title="$t('report.Export_report')"
  >
    <div slot="content" class="grid">
      <span class="label">
        {{$t('report.Report_type')}}
      </span>
      <el-radio-group v-model="activeType" v-removeAriaHidden>
        <el-radio label="day">{{$t('report.Daily_report')}}</el-radio>
        <el-radio label="month">{{$t('report.Monthly_report')}}</el-radio>
        <el-radio label="year">{{$t('report.Yearly_Report')}}</el-radio>
        <el-radio label="total">{{$t('report.Total_report')}}</el-radio>
        <!-- <el-radio label="range">自定义</el-radio> -->
      </el-radio-group>
      <span v-show="activeType!='total'" class="label">
        {{$t('report.Report_date')}}
      </span>
      <el-date-picker
        :clearable="false"
        v-model="datevalue"
        v-show="activeType==='day'"
        ref="datePickerDay"
        type="date"
        :placeholder="$t('report.select_date')"
      >
      </el-date-picker>
      <el-date-picker
      :clearable="false"
        v-model="datevalue"
        v-show="activeType==='month'"
        type="month"
        ref="datePickerMonth"
        :placeholder="$t('report.select_date')"
      >
      </el-date-picker>
      <el-date-picker
      :clearable="false"
        v-model="datevalue"
        v-show="activeType==='year'"
        type="year"
        ref="datePickerYear"
        :placeholder="$t('report.select_date')"
      >
      </el-date-picker>
      <!-- <el-date-picker
        v-model="datevalue"
        v-show="activeType==='range'"
        type="daterange"
        align="left"
        unlink-panels
        :default-value="new Date().setMonth(new Date().getMonth() - 1)"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placeholder="请选择日期"
        style="width:380px"
      >
      </el-date-picker> -->
    </div>
    <div slot="footer">
      <!-- <button
        class="button-hollow"
        @click="closeDialog"
      >{{$t('report.cancel')}}</button> -->
      <button
        class="button-solid"
        @click="exportPlant"
      >{{$t('report.Export')}}</button>
    </div>
  </export-plant-dialog>
</template>
<script>
import exportPlantDialog from "@/components/dialog/index";
import encryption from "@/assets/js/encryption";
// import qs from 'qs';
import request from "@/assets/js/request";
import config from '@/assets/js/config';
import cookie from '@/assets/js/cookie';
export default {
  components: {
    exportPlantDialog
  },
    state: {
    token: null,
  },
  props: {
    params: {
      default: null
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.closeDialog();
        this.$refs.datePickerDay.handleClose()
        this.$refs.datePickerMonth.handleClose()
        this.$refs.datePickerYear.handleClose()
        // this.$refs["datePickerDay","datePickerMonth","datePickerYear"].pickerVisible = false
      }
    },
    params(val) {
      this.dialogVisible = !!val;
    }
  },
  data() {
    return {
      dialogVisible: false,
      radio: "1",
      datevalue: new Date(),
      monthlyvalue: "",
      yearvalue: "",
      totalvalue: "",
      customizevalue: "",
      activetime: "daily",
      activeType: "day"
    };
  },
  methods: {
  // 关闭弹窗
    closeDialog() {
      this.$emit("update:params", null);
    },
    //导出报表
    exportPlant() {
      // 导出单个报表
      if(this.params !== 'all') {
       var PNAll =[]
       this.params.forEach(item => {
         PNAll.push(item.pn)
       });
       this.pnbox = PNAll
        let action, param = {
          action: 'exportCollectorsData',
          i18n: this.$lang.currentLang,
          // pns: this.params.pn,
          pns: this.pnbox.join(','),
        }
        switch (this.activeType) {
          // 日报表
          case 'day':
          default:
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth()+1,
              day: this.datevalue.getDate(),
            }
            break;
          // 月报表
          case 'month':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth()+1,
            }
            break;
          // 年报表
          case 'year':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
            }
            break;
          // 总报表
          case 'total':
            break;
          // 区间报表
          // case 'range':
          //   action = 'exportCollectorsData'
          //   param = {
          //     ...param,
          //     sdate: util.formatDate(this.datevalue[0]),
          //     edate: util.formatDate(this.datevalue[1])
          //   }
          //   break;
        }
        // 重复已注释
        // this.$message.success(this.$t("report.download"));
        this.$request.get(action, param)
          .then((res) => {
            // 演示账号
            if(res.err){
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            }else{
              // ......................
              window.location.href = this.$request.http_download_url_new(param)
              this.closeDialog();
              // ......................
            }
            this.$message.success(this.$t("report.download"));
          }).then(() => {
            // this.$message.success(this.$t("report.download"));
          }).catch((err) => {
            this.$message.error(err);
          });
      }
      // 导出所有报表 
      else {
        let action, param = {
          action: 'exportCollectorsData',
          i18n: this.$lang.currentLang,
        } // 生成报表所需参数
        switch (this.activeType) {
          // 日报表
          case 'day':
          default:
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth()+1,
              day: this.datevalue.getDate(),
            }
            break;
          // 月报表
          case 'month':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth()+1,
            }
            break;
          // 年报表
          case 'year':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
            }
            break;
          // 总报表
          case 'total':
            break;
          // 区间报表
          // case 'range':
          //   action = 'exportCollectorsData'
          //   param = {
          //     ...param,
          //     sdate: util.formatDate(this.datevalue[0]),
          //     edate: util.formatDate(this.datevalue[1])
          //   }
          //   break;
        }
        this.$message.success(this.$t("report.download"));
        this.$request.get(action, param)
        .then((res) => {
            // 演示账号
            if(res.err){
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            }else{
              // ......................
              window.location.href = this.$request.http_download_url_new(param)
              this.closeDialog();
              // ......................
            }
            this.$message.success(this.$t("report.download"));
          })
          .then(() => {
            // this.$message.success(this.$t("report.download"));
          }).catch((err) => {
            this.$message.error(err);
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.exportPlant {
  .label {
    font-size: 14px;
    color: #606266;
    margin-right: 20px;
  }
  .el-input__icon{
    line-height: 32px
  }
}
</style>


